import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { comparisonRows } from '../data/content';
export function ComparisonTable() {
  return <section aria-labelledby="comparacion" className="border-y border-line bg-canvasAlt" data-id="element-36" data-mp="2pnth9b3sxv97">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-10" data-id="element-37" data-mp="2um4rhmy0e7ry">
        <Reveal data-id="element-38" data-mp="2uka4m336g5l8">
          <h2 id="comparacion" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-39" data-mp="3ici9slqsks9c">
            ¿Qué cambia con el Kit Emprendedor Pro?
          </h2>
        </Reveal>

        <Reveal delay={0.04} className="mt-5 overflow-x-auto" data-id="element-40" data-mp="38cztcfa3bom1">
          <table className="w-full min-w-[36rem] border-collapse text-left" data-id="element-41" data-mp="3dd5rmeav89d3">
            <thead data-id="element-42" data-mp="3df8nheyp8wpq">
              <tr className="border-b border-lineStrong" data-id="element-43" data-mp="1wyw39k6mikm9">
                <th className="py-3 pr-4 text-xs font-bold uppercase tracking-wide text-ink-subtle" data-id="element-44" data-mp="1wxb8btgecznv">
                  Situación
                </th>
                <th className="py-3 px-4 text-xs font-bold uppercase tracking-wide text-ink-subtle" data-id="element-45" data-mp="2dwvulslhffrt">
                  Sin Kit Pro
                </th>
                <th className="py-3 pl-4 text-xs font-bold uppercase tracking-wide text-accent" data-id="element-46" data-mp="29xn20r26hnxu">
                  Con Kit Pro
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-47" data-mp="2ivqk1ddyg2kw">
              {comparisonRows.map(row => <tr key={row.sit} data-id="element-48" data-mp="2wuqbstwrkxla">
                  <td className="py-3 pr-4 text-sm font-semibold text-ink" data-id="element-49" data-mp="2wtx4nrtw862m">
                    {row.sit}
                  </td>
                  <td className="py-3 px-4 text-sm text-ink-subtle" data-id="element-50" data-mp="36mme6h5vv9vb">
                    <span className="flex items-center gap-2" data-id="element-51" data-mp="36nxhygzbwhmf">
                      <XIcon size={14} className="flex-shrink-0 text-danger" strokeWidth={2.5} data-id="element-52" data-mp="31njfdeghxzvs" />
                      {row.sin}
                    </span>
                  </td>
                  <td className="py-3 pl-4 text-sm font-semibold text-ink" data-id="element-53" data-mp="3ip5hvm89mp45">
                    <span className="flex items-center gap-2" data-id="element-54" data-mp="3nn78qtbxnsq6">
                      <CheckIcon size={14} className="flex-shrink-0 text-accent" strokeWidth={3} data-id="element-55" data-mp="3nnqkfsazpkvr" />
                      {row.con}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Reveal>

        <p className="mt-5 font-display text-lg md:text-xl font-extrabold uppercase text-ink" data-id="element-56" data-mp="a7j3aghe01qp">
          Es la diferencia entre solamente aprender Electrónica{' '}
          <span className="text-accent" data-id="element-57" data-mp="k6qi783rs4fx">y empezar a hacer algo con ella.</span>
        </p>
      </div>
    </section>;
}